import { render, staticRenderFns } from "./SaleEditVatRegimeSelect.vue?vue&type=template&id=e55934c4&scoped=true"
import script from "./SaleEditVatRegimeSelect.vue?vue&type=script&lang=ts"
export * from "./SaleEditVatRegimeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55934c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e55934c4')) {
      api.createRecord('e55934c4', component.options)
    } else {
      api.reload('e55934c4', component.options)
    }
    module.hot.accept("./SaleEditVatRegimeSelect.vue?vue&type=template&id=e55934c4&scoped=true", function () {
      api.rerender('e55934c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditVatRegimeSelect.vue"
export default component.exports